React = require 'react'
t = require('views/internal/recup-with-helpers')()

module.exports = class extends React.Component
  displayName: 'HomeSectionHeaderComponent'
  render: t.renderable ->
    { title, iconClass, smallIconClass, smallIconTitleKey, linkElements } = @props

    t.div { class: t.classify('home-section-header': true, 'no-icon': !iconClass) }, ->

      if iconClass
        t.div '.home-section-header-icon', ->
          t.span { class: "icon-sm icon-#{iconClass}" }

      t.h3 '.home-section-header-name', ->
        t.text title

      if smallIconClass
        t.span '.home-section-header-small-icon', ->
          t.icon smallIconClass, { title: t.l(smallIconTitleKey) }

      if linkElements
        t.div '.home-section-header-options', ->
          for link in linkElements
            t.addElement link



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-section-header-component.coffee